module.exports = __webpack_public_path__ + "static/media/19ESCAP6.b39a35b0.jpg";